import { Pipe, PipeTransform } from '@angular/core';
import { formatPrice } from '../functions/functions';

/** Prices are shown without grouping or trailing decimals, e.g. `1150€` (matches the public price list). */
@Pipe({
  standalone: true,
  name: 'currencyNumber',
})
export class CurrencyNumberPipe implements PipeTransform {
  transform(value: number | string | undefined | null): string {
    if (value === undefined || value === null) return '';
    const numberValue = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(numberValue)) return '';

    return `${formatPrice(numberValue)}€`;
  }
}
